<template>
    <div class="elr-conent-bill">
        <div class="lefts">
            <el-row :gutter="20" :data="infoData">
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <div class="label">
                            客户名称：
                            <span
                                class="value"
                                :title="infoData.ledgerName"
                            >{{infoData.ledgerName}}</span>
                        </div>
                        <div class="label">
                            结算批金额：
                            <span
                                class="value"
                                :title="infoData.localTotalAmt"
                            >{{infoData.localTotalAmt}}</span>
                        </div>
                        <div class="label">
                            预开油卡发票金额：
                            <span
                                class="value"
                                :title="infoData.oilCardAmountPaid"
                            >{{preAmt}}</span>
                        </div>
                        <div class="label">
                            安得业务对接人：
                            <span
                                class="value"
                                :title="infoData.confirmor"
                            >{{infoData.confirmor}}</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="grid-content bg-purple">
                        <div class="label">
                            分公司：
                            <span
                                class="value"
                                :title="infoData.companyNameNew"
                            >{{infoData.companyNameNew}}</span>
                        </div>
                        <div class="label">
                            票前扣款金额：
                            <span
                                class="value"
                                :title="infoData.fineAmt"
                            >{{infoData.fineAmt}}</span>
                        </div>
                        <div class="label">
                            核销总金额：
                            <span
                                class="value"
                                :title="infoData.totalAmt"
                            >{{ cancelAmt }}</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="grid-content bg-purple">
                        <div class="label">
                            币种：
                            <span
                                class="value"
                                :title="infoData.currencyCode"
                            >{{infoData.currencyCode}}</span>
                        </div>
                        <!-- 占位使用 -->
                        <div class="label">
                            <span
                                class="value"
                            ></span>
                        </div>
                        <div class="label">
                            应收款金额：
                            <span
                                class="value"
                                :title="infoData.apRealAmt"
                            >{{infoData.apRealAmt}}</span>
                        </div>

                        <!-- <div class="label">
                            已付款金额：
                            <span
                                class="value"
                                :title="infoData.payedAmt"
                            >{{infoData.payedAmt}}</span>
                        </div> -->
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="rights">
            <div class="rights-l">
                <div v-for="(item, index) in taxRateData" :key="index" class="rights-d">
                    <span>业务类型：{{item.feeTaskTypeText}}</span> ，
                    <span>税率：{{item.taxRate}}</span> ，<span>应开票：{{item.value}} 元</span>
                </div>
                <div class="rights-t">总开票金额：{{infoData.totalAmountText}} 元</div>
            </div>
            <div class="rights-r" >
                <div class="prices" v-if="infoData.settlementProcess !== 1">
                    {{infoData.totalAmount ? infoData.totalAmount : 0}}
                    <span class="prices-m">元</span>
                </div>
                <div class="amount" v-if="infoData.settlementProcess !== 1">已上传发票金额</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        infoData: {
            type: Object
        },
        taxRateData: {
            type: Array
        },
        isPayedAmt: {
            type: Boolean
        },
        cancelAmt: {
            type: Number,
            default: 0.0
        },
        preAmt: {
            type: Number,
            default: 0.0
        }
    },
    data() {
        return {
            data: {}
        };
    }
};
</script>

<style lang="less" >
.elr-conent-bill {
    display: flex;
    .lefts {
        flex: 4;
    }
    .rights {
        flex: 3;
        display: flex;
    }
    .rights-l {
        color: #666;
        font-size: 14px;
        flex: 3;
        text-align: center;
        line-height: 20px;
        border-right: 1px solid;
        border-color: #ddd;
        overflow: scroll;
    }
    .rights-t {
        margin-top: 20px;
    }
    .rights-d {
        text-align: left;
        margin-left: 40px;
    }
    .rights-r {
        flex: 2;
        text-align: center;
    }
    .prices {
        margin-top: 6px;
        font-size: 24px;
        color: #ff8800;
    }
    .amount {
        font-size: 14px;
        color: #333;
        margin-top: 10px;
    }
    .prices-m {
        color:#000;
        font-size: 14px;
    }
}
</style>
